export default "__VITE_ASSET__DABV9Bci__"